import {BaseUrlService} from 'core/base/BaseUrlService';
import {PageInfo} from 'models';
import {BaseUrlParam} from 'core/base/BaseUrlParam';

export class PaginationUrlService extends BaseUrlService {
    public static readonly COMMON_PARAM_NAMES = {
        PAGE: new BaseUrlParam('page', false),
    };

    constructor(
        query: BaseUrlService['query'],
        onParamsChange: BaseUrlService['onParamsChange'],
        options: BaseUrlService['options'],
    ) {
        super(query, onParamsChange, options);

        this.fill(Object.values(PaginationUrlService.COMMON_PARAM_NAMES), 'include');
        this.format();
    }

    public async setPageParam(page: PageInfo['pageNumber']) {
        await this.addParam({id: PaginationUrlService.COMMON_PARAM_NAMES.PAGE.toString(), value: page.toString()});
    }
}
